export class ChatDetail{
  idUser:number;
  uid:string;
  lastSeen?:Date;
  isMessageRead?: Boolean;
}
